module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/trekking.bc7494c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/trekking.jpg
// module id = N2Ph
// module chunks = 0